import {
  Card,
  Typography,
  Avatar,
  Tooltip,
  useTheme,
  Box,
  // CardActionArea,
  Divider,
  Badge,
  IconButton,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'
import { CustomerInfo } from './InvestigatingOfficer'
import { ReactComponent as OpenIcon } from '../../assets/icons/OpenIcon.svg'

const styles = (theme: any) => ({
  card: {
    borderRadius: '20px',
  },
  cardArea: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    // margin: theme.spacing(1, 0),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    flexWrap: 'no-wrap',
    rowGap: 3,
    gap: '10px',
  },
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    // flexWrap: 'wrap',
  },
  avatar: {
    width: 50,
    height: 50,
    // border: "2px solid #f39c12", // Orange border
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },

  iconButton: {
    color: theme.palette.primary.main,
  },
  label: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: Colors.TEXT_COLOR_TERTIARY,
  },
  value: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: Colors.TEXT_COLOR_MAIN,
  },

  name: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: 'orange',
      color: 'green',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
})

const CustomerInfoCard = ({
  data,
  onClick,
}: {
  data: CustomerInfo
  onClick: () => void
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <Box className={classes?.cardArea}>
        <Box className={classes?.avatarContainer}>
          <Badge
            overlap='circular'
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            variant='dot'
            className={classes?.badge}
          >
            <Avatar
              className={classes?.avatar}
              alt='Anya'
              src={`https://i.pravatar.cc/150?img=${Math.random()}`}
            />
          </Badge>
          <Box className={classes?.textContent}>
            <Tooltip title={data?.name} placement='right'>
              <Typography
                className={classes?.name}
                width={'220px'}
                noWrap
                textOverflow={'ellipsis'}
                overflow={'hidden'}
              >
                {data?.name}
              </Typography>
            </Tooltip>
            <Typography className={classes?.name}>
              {data?.phoneNumber}
            </Typography>
          </Box>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box className={classes?.details} minWidth={'120px'}>
          <Typography className={classes?.label}>
            MRN NO - <span className={classes?.value}>{data?.mrnNo}</span>
          </Typography>
          <Typography className={classes?.label}>
            ABA ID - <span className={classes?.value}>{data?.abaId}</span>
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box className={classes?.info} minWidth={'120px'}>
          <Typography className={classes?.label}>No. of People</Typography>
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={1}
          >
            <Typography className={classes?.value}>
              {data?.numberOfPeople}
            </Typography>
            <Tooltip title='More information'>
              <InfoOutlinedIcon
                fontSize='small'
                className={classes?.iconButton}
              />
            </Tooltip>
          </Box>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box className={classes?.details} minWidth={'120px'}>
          <Typography className={classes?.label}>Lab Test</Typography>
          <Typography className={classes?.value}>
            {data?.labTestStatus}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box className={classes?.details} minWidth={'120px'}>
          <Typography className={classes?.label}>
            Physical Examination
          </Typography>
          <Typography className={classes?.value}>
            {data?.physicalExamStatus}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box className={classes?.details} minWidth={'160px'}>
          <Typography>
            <span className={classes?.label}>Received Date -</span>{' '}
            <span className={classes?.value}>{data?.receivedDate}</span>
          </Typography>
          <Typography>
            <span className={classes?.label}>Approved Date -</span>{' '}
            <span className={classes?.value}>{data?.approvedDate}</span>
          </Typography>
        </Box>
        <Box className={classes?.actions}>
          <IconButton color='primary' onClick={onClick}>
            <OpenIcon />
          </IconButton>
        </Box>
      </Box>
    </Card>
  )
}

export default CustomerInfoCard
